import React, { useEffect } from 'react';
import { Button, Col, Form, Modal, Row } from 'antd';
import { FormBox, InputBox } from '../../../../components/AntdAddons';
import { validations } from '../../../../config/validations/validations';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faTimes } from '@fortawesome/free-solid-svg-icons';
import { AppDispatch } from '../../../../store/app';
import { useDispatch } from 'react-redux';
import { updateEmailInProvider } from '../../../../store/ProviderSlice';

const UpdateEmail: React.FC<any> = (props) => {
  const { openUpdateModal, handleUpdateEmail, openUpdateData, getList } = props;

  const dispatch: AppDispatch = useDispatch();
  const [form] = Form.useForm();

  useEffect(() => {
    if (openUpdateData) {
      form.setFieldValue('provider', openUpdateData?.provider_code);
      form.setFieldValue('email', openUpdateData?.email);
    }
  }, [openUpdateData, form]);

  const handleSubmit = (data) => {
    const payload = {
      provider_code: openUpdateData?.provider_code,
      email: data?.email,
    };
    dispatch(updateEmailInProvider(payload))
      .then(() => {
        handleUpdateEmail();
        getList();
        // form.resetFields();
      })
      .catch(() => {
        handleUpdateEmail();
      });
  };
  // for validation
  const handleChange = () => {
    form
      .validateFields()
      .then(() => {
        // setDisable(false);
      })
      .catch((error: any) => {
        // setDisable(true);
      });
  };

  return (
    <>
      <Modal
        open={openUpdateModal}
        destroyOnClose
        width={800}
        onCancel={() => {
          handleUpdateEmail();
          form.resetFields();
        }}
        closeIcon={<FontAwesomeIcon icon={faTimes} />}
        footer={false}
        className='addModal'
        title={`Update Port Time Request`}>
        <FormBox
          className='filterForm'
          form={form}
          onFinish={handleSubmit}
          onChange={handleChange}
          validateTrigger={['onBlur', 'onInput']}
          autoComplete='off'>
          <Row gutter={20} align={'top'}>
            <Col xs={24} md={12}>
              <InputBox.Text label='Provider' name={'provider'} disabled />
            </Col>
            <Col xs={24} md={12}>
              <InputBox.Text
                label='Email'
                name={'email'}
                rules={[validations.pattern.multiEmail('Email')]}
                tooltip='Comma separated multiple email can be added.'
              />
            </Col>
            <Col xs={12} md={12} lg={6}>
              <Button type='primary' htmlType='submit'>
                Submit
              </Button>
            </Col>
          </Row>
        </FormBox>
      </Modal>
    </>
  );
};

export default UpdateEmail;
